import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './css/index.css';
// Import environment configuration to ensure it's loaded
import './env.js';
// Import i18n configuration
import './i18n.js';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
